import { FC } from 'react'
import TextField from './Text'
import TextAreaField from './TextArea'
import RadioField from './Radio'
import CheckboxField from './Checkbox'
import MultipleCheckboxField from './MultipleCheckbox'
import SelectField from './Select'
import ListField from './List'
import HeadingField from './Heading'
import HTMLField from './HTML'

import { defaultValues as DEFAULTS } from '../../../../utils/form'

import {
  FormFieldProps,
} from '../../../../types/frontend/form'

const fields: Record<string, FC<React.PropsWithChildren<FormFieldProps>>> = {
  text: TextField,
  textarea: TextAreaField,
  radio: RadioField,
  checkbox: CheckboxField,
  multipleCheckbox: MultipleCheckboxField,
  select: SelectField,
  list: ListField,
  heading: HeadingField,
  html: HTMLField,
}

export type ComponentName = string

export const defaultValues = DEFAULTS

export default fields